import React from 'react';
import { compact } from 'lodash';
import { Link } from 'react-router-dom';
import { Typography, TableList } from 'seagull';
import { routes } from "../../../constants";
import { ActiveServicesReportOptionalColumns } from "./types";
export const ActiveServiceRow = props => {
  const {
    visibleColumns,
    data
  } = props;
  const items = compact([{
    value: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      as: Link,
      to: routes.agreement(data.relationshipId),
      "data-testid": "active-services-report-row-customer",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true
    }, data.customerName), /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-agreement",
      variant: "paragraph2",
      skin: "secondary"
    }, data.agreementName))
  }, {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-service",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true
    }, data.serviceName)
  }, visibleColumns[ActiveServicesReportOptionalColumns.Trigger] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-trigger",
      variant: "paragraph1",
      noWrap: true
    }, data.trigger)
  }, visibleColumns[ActiveServicesReportOptionalColumns.Pricing] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-pricing",
      variant: "paragraph1",
      noWrap: true
    }, data.pricing)
  }, visibleColumns[ActiveServicesReportOptionalColumns.Occurrence] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-occurrence",
      variant: "paragraph1",
      noWrap: true
    }, data.occurrence)
  }, visibleColumns[ActiveServicesReportOptionalColumns.Rate] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-rate",
      variant: "paragraph1",
      noWrap: true
    }, data.rate)
  }, visibleColumns[ActiveServicesReportOptionalColumns.LastBilled] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-last-billed",
      variant: "paragraph1",
      noWrap: true
    }, data.formattedLastBilled || '-')
  }, visibleColumns[ActiveServicesReportOptionalColumns.Assignee] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-assignee",
      variant: "paragraph1",
      noWrap: true
    }, data.assignee)
  }, visibleColumns[ActiveServicesReportOptionalColumns.AutomaticServiceState] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-paused",
      variant: "paragraph1",
      noWrap: true
    }, data.automaticServiceState == null ? '-' : data.automaticServiceState)
  }, visibleColumns[ActiveServicesReportOptionalColumns.Status] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-status",
      variant: "paragraph1",
      noWrap: true
    }, data.status)
  }]);
  return /*#__PURE__*/React.createElement(TableList.Row, {
    items: items,
    rowId: props.index,
    "data-testid": "active-services-report-row-".concat(props.index),
    "data-heapid": "active-services-report-row"
  });
};